import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissionsArray } from '@/shared';
import { useGetObservacion } from '@/shared/actions/erp/observacion.action';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveObservacion } from '../../shared/componets';

export type UpdateObservacionPageProps = {};

const UpdateObservacionPage: React.FC<UpdateObservacionPageProps> = () => {
  useCheckPermissionsArray([
    PermissionsEnum.api_change_observacion
  ]);

  const { id } = useParams();

  const { data, isLoading } = useGetObservacion(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_observacion) return <Navigate to={ROUTER_PATHS.administration.observacionNav}/>;

  return <SaveObservacion titlePage="Editar Observacion" observacionEditar={data.data} />;
};

export default UpdateObservacionPage;
